module.exports = __webpack_public_path__ + "media/home1-right.7670885a.mp4";